import institutionAPI from 'services/institutionAPI'

export default async function getLoggedUserPermissions() {
  const response = await institutionAPI({
    method: 'POST',
    url: '/auth/person-auth/is-auth/permissions',
  })

  return response
}
